// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1VE3j","footer":"ModalCreateQualiphyProcedure_footer__d6jse","additionData":"ModalCreateQualiphyProcedure_additionData__2UIla"};